/**
 * Composant ImageModeSelector
 * Sélection du mode d'image pour la génération d'articles
 */
import React from 'react';
import { Input } from '../../components/ui/input';

export const ImageModeSelector = ({
  imageMode,
  imageSearchKeyword,
  onImageModeChange,
  onImageSearchKeywordChange,
}) => {
  return (
    <div className="p-3 bg-slate-900/40 border border-slate-700 rounded-lg space-y-3">
      <p className="text-sm text-slate-300 font-semibold">Image de l&apos;article</p>
      <div className="space-y-2">
        <label className="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-slate-800/50 transition-colors" data-testid="image-mode-none">
          <input 
            type="radio" 
            name="image-mode" 
            value="none" 
            checked={imageMode === 'none'} 
            onChange={() => onImageModeChange('none')} 
            className="accent-slate-500" 
          />
          <span className="text-sm text-slate-400">Pas d&apos;image</span>
        </label>
        <label className="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-slate-800/50 transition-colors" data-testid="image-mode-ai">
          <input 
            type="radio" 
            name="image-mode" 
            value="ai" 
            checked={imageMode === 'ai'} 
            onChange={() => onImageModeChange('ai')} 
            className="accent-cyan-500" 
          />
          <span className="text-sm text-slate-300">Image IA <span className="text-xs text-slate-500">(comics 60s, +20s, +0.02€)</span></span>
        </label>
        <label className="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-slate-800/50 transition-colors" data-testid="image-mode-periscope">
          <input 
            type="radio" 
            name="image-mode" 
            value="periscope" 
            checked={imageMode === 'periscope'} 
            onChange={() => onImageModeChange('periscope')} 
            className="accent-purple-500" 
          />
          <span className="text-sm text-purple-300">Pexels <span className="text-xs text-slate-500">(6 options, gratuit)</span></span>
        </label>
        <label className="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-slate-800/50 transition-colors" data-testid="image-mode-both">
          <input 
            type="radio" 
            name="image-mode" 
            value="ai+periscope" 
            checked={imageMode === 'ai+periscope'} 
            onChange={() => onImageModeChange('ai+periscope')} 
            className="accent-amber-500" 
          />
          <span className="text-sm text-amber-300">IA + Pexels <span className="text-xs text-slate-500">(1 IA + 6 Pexels, 7 choix)</span></span>
        </label>
      </div>
      {(imageMode === 'periscope' || imageMode === 'ai+periscope') && (
        <div className="mt-3">
          <label className="text-xs text-slate-500 uppercase tracking-wider">Mot-clé de recherche image</label>
          <Input
            value={imageSearchKeyword}
            onChange={(e) => onImageSearchKeywordChange(e.target.value)}
            placeholder="ex: electric car, gold price, parliament..."
            className="mt-1 bg-slate-900/50 border-slate-700 text-slate-200 placeholder:text-slate-600 text-sm"
            data-testid="image-search-keyword"
          />
          <p className="text-[10px] text-slate-600 mt-1 italic">En anglais, la recherche donne de meilleurs résultats. Laissez vide pour utiliser le focus keyword SEO.</p>
        </div>
      )}
    </div>
  );
};

export default ImageModeSelector;
